import React, { useEffect, useState } from 'react'
import ProductSection from '../../components/common/ProductsSection'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import ArrowDown from '../../assets/icons/ArrowDown'
import MainFilter from '../../components/filter_product/MainFilter'
import PageTitle from '../../components/common/PageTitle'
import ProductCard from '../../components/cards/ProductCard'
import WhyUsSection from '../../components/common/WhyUsSection'
import OurMissionSection from '../../components/common/OurMissionSection'
import { useDispatch, useSelector } from 'react-redux'
import { getCategories, getProducts } from '../../services/actions/MainAction'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Sparkles } from 'lucide-react'

function Products() {
    const [categoryId, setCategoryId] = useState('');
    const [subCategoryId, setSubCategoryId] = useState('');
    const contentData = useSelector(state => state.Data.contentData);
    const lang_id = useSelector(state => state.Data.lang_id);
    const productsData = useSelector(state => state.Data.productsData);
    const categoresData = useSelector(state => state.Data.categoresData);
    const [searchParams] = useSearchParams();
    const categoryIdSearch = searchParams.get("category_id");
    const categorySubIdSearch = searchParams.get("sub_category_id");
    const navigate = useNavigate();
    useEffect(()=>{
      if(categoryIdSearch){
        navigate("/products")
        setCategoryId(categoryIdSearch)
      }
      if(categorySubIdSearch){
        setSubCategoryId(categorySubIdSearch)
      }
    },[categoryIdSearch, categorySubIdSearch])
    const dispatch = useDispatch();
    useEffect(()=>{
      dispatch(getProducts(lang_id, categoryId, subCategoryId));
      window.scrollTo(0,0)
    },[lang_id, categoryId, subCategoryId])
    useEffect(()=>{
      dispatch(getCategories(lang_id))
    },[lang_id])
  return (
    <main className='w-full'>
      {/* <PageTitle title={contentData?.nav_3} /> */}
      <div className="relative overflow-hidden bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 py-16">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 border-2 border-blue-400 rounded-full animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-48 h-48 border-2 border-amber-400 rounded-full animate-pulse"></div>
        </div>

        <div className="relative container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 rounded-full mb-6 border border-blue-400/30 backdrop-blur-sm">
              <Sparkles className="w-4 h-4 text-blue-300" />
              <span className="text-sm font-medium text-blue-100"> {contentData?.nav_3}</span>
              <Sparkles className="w-4 h-4 text-amber-300" />
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">
              <span className="bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
                {contentData?.nav_3}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div className='px-[20px] gap-[50px] flex items-start mt-[30px] justify-center max-[1240px]:gap-[0px] max-[1000px]:flex-col max-[1000px]:px-0'>
       {/* {categoresData?.length !=0? <MainFilter subCategoryId={subCategoryId} setSubCategoryId={(id)=>setSubCategoryId(id)} categoryId={categoryId} setCategoryId={(id)=>setCategoryId(id)} />:null}  */}
        <div className="max-[1000px]:mt-[30px] max-[1000px]:w-full">
          <div className='container'>
            <div className='grid grid-cols-3 gap-[40px] max-[1200px]:grid-cols-2 max-[600px]:grid-cols-1 max-[600px]:gap-[20px]'>
              {
                productsData?.map((data, i)=>{
                  return (
                    <ProductCard  key={i} data={data} />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
      {/* <OurMissionSection /> */}
      <WhyUsSection />
    </main>
  )
}

export default Products
